import { render } from "./inclusioneOrariModal.vue?vue&type=template&id=159ff38a&ts=true"
import script from "./inclusioneOrariModal.vue?vue&type=script&lang=ts"
export * from "./inclusioneOrariModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__